import isEmpty from 'validator/lib/isEmpty'
import isEmail from 'validator/lib/isEmail'

const validators = {
  isRequired: value => {
    if (value === undefined) return false
    return !isEmpty('' + value)
  },
  isEmail: value => {
    return isEmail('' + value)
  }
}

export default function validateForm(fieldsMap) {
  return values => {
    if (!values) return null

    return Object.keys(values).reduce((acc, key) => {
      if (!(fieldsMap[key] && fieldsMap[key].validation)) return acc
      const validations = fieldsMap[key].validation
      const value = values[key]
      const error = Object.keys(validations).find(key => {
        return !validators[key](value)
      })

      if (error) {
        acc[key] = fieldsMap[key].validation[error]
      }
      return acc
    }, {})
  }
}



// WEBPACK FOOTER //
// ./client/utils/validateForm.js